import { useQuery } from "@tanstack/react-query";
import { OrganizationService } from "../../data/services/OrganizationService";
import { useOrganizationStore } from "../../stores/useOrganizationStore";
import { useAuthStore } from "../../stores/useAuthStore";
import type { Organization } from "../types";

interface UseOrganizationsResult {
  organizations: Organization[];
  loading: boolean;
  error: string | null;
}

export function useOrganizations(): UseOrganizationsResult {
  const { organizations, setOrganizations } = useOrganizationStore();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  const { isLoading, error } = useQuery({
    queryKey: ["organizations"],
    queryFn: async () => {
      const response = await OrganizationService.fetchOrganizations();
      setOrganizations(response); // keep store in sync as before
      return response;
    },
    enabled: isAuthenticated,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    // No staleTime — let React Query refetch when enabled condition is met
  });

  return {
    organizations,
    loading: isLoading,
    error: error ? "Failed to load organizations" : null,
  };
}
